import numeric from "./numeric";

const requiredNumeric = (value) => {
  if (value === undefined || value === null) return 'Required';
  if (typeof value === 'string' && value.trim() === '') return 'Required';
  if (typeof value === 'number' && Number.isNaN(value)) return 'Required';
  return numeric(value);
}

export default requiredNumeric;